import { useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    CircularProgress,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CancelIcon from '@material-ui/icons/Cancel';
import './CollapsableSteps.scss';
import PublishStatusType from '@enums/PublishStatusType';
import ErrorTable from './ErrorTable';

/**
 * @typedef {{
 *  name: string,
 *  error: string,
 * }} StepError
 * @typedef {{
 *  stepLabel: string,
 *  statusLabel: string,
 *  stepNumber: WorkplanPublishStepCode,
 *  stepStatus: number,
 *  errors: StepError[],
 * }} StepInformation
 * @param {{
 * stepInfo: StepInformation[],
 * }} param0
 */
function CollapsableSteps({ stepInfo }) {
    const [expanded, setExpanded] = useState('');
    
    /**
     * @param {StepInformation} step 
     * @param {number} index 
     */
    const handleChange = (step, index) => (event, isExpanded) => {
        if (step.errors.length) {
            setExpanded(isExpanded ? `panel${index}` : '');
        }
    };

    const renderCurrentStepStatus = (x) => {
        switch (x.stepStatus) {
            case PublishStatusType.Publishing:
                return (
                    <CircularProgress
                        size={20}
                    />
                );
            case PublishStatusType.Success:
                return (
                    <>
                        <span className="text-sm-regular step-status-label">{x.statusLabel}</span>
                        <CheckCircleIcon className="step-status-icon" fontSize="small" />
                    </>
                );
            case PublishStatusType.Warning:
                return (
                    <>
                        <span className="text-sm-regular step-status-label">{x.statusLabel}</span>
                        <ErrorIcon className="step-status-icon" fontSize="small" />
                    </>
                );
            case PublishStatusType.Error:
                return (
                    <>
                        <span className="text-sm-regular step-status-label">{x.statusLabel}</span>
                        <CancelIcon className="step-status-icon" fontSize="small" />
                    </>
                );
            case PublishStatusType.CouldNotRun:
                return (
                    <>
                        <span className="text-sm-regular step-status-label">{x.statusLabel}</span>
                        <ErrorOutlineIcon className="step-status-icon" fontSize="small" />
                    </>
                );
            default:
                return null;
        }
    };
    return (
        <div className="cs--root">
            {stepInfo.map((x, i) => (
                <Accordion
                    key={x.stepNumber}
                    className="cs-accordion"
                    disabled={x.stepStatus === PublishStatusType.CouldNotRun}
                    expanded={expanded === `panel${i}`}
                    onChange={handleChange(x, i)}
                >
                    <AccordionSummary className={`cs-summary ${!x.errors.length && 'not-clickable'}`} classes={{ content: `${!x.errors.length && 'not-clickable'}` }}>
                        <div className="cs-summary-content">
                            <div className="cs-accordion-step-left">
                                <span className="text-lg-semibold">
                                    {x.stepLabel}
                                </span>
                            </div>
                            <div className="cs-accordion-step-right">
                                {renderCurrentStepStatus(x)}
                            </div>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {x.errors.length ? (
                            <ErrorTable
                                rows={x.errors}
                            />
                        ) : null }
                    </AccordionDetails>
                </Accordion>
            ))}
            
        </div>
    );
}

export default CollapsableSteps;
